import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProductionLineGroupJobQueueView } from "src/components/views/erp/production/jobQueue/ProductionLineGroupJobQueueView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/production/productionLineGroupJobQueue")({
	staticData: { title: i18n.t("production_line_group_job_queue"), legacyViewKey: "productionLineGroupJobQueuePage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <ProductionLineGroupJobQueueView isActive={isActive} />;
}
